<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="カレンダー連携"
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        ok-only>
        <template>
            <div class="text mb-3 alert alert-info">
                <b-icon-info-circle-fill/>&nbsp;ヨクミルの相談予約スケジュールをGoogleカレンダー等のウェブスケジュール登録ツールに連携できます。
            </div>
            <div class="mb-2">
                <label class="form-control-label">カレンダー連携のオン／オフ切り替え</label>
                <div class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                    <div class="m-radio-inline">
                        <label class="m-radio mr-2 pt-1">
                            <input v-model="calendar.is_public"
                                    type="radio"
                                    name="is_public"
                                    :value="1"
                                    @change="changeIsPublic()">
                            <span>ON</span>
                        </label>
                        <label class="m-radio mr-2 pt-1">
                            <input v-model="calendar.is_public"
                                    type="radio"
                                    name="is_public"
                                    :value="0"
                                    @change="changeIsPublic()">
                            <span>OFF</span>
                        </label>
                    </div>
                    <div
                        v-if="calendar.is_public"
                        class="mt-1">
                        <div class="form-group m-form__group">
                            <label for="calendar_url">カレンダーURL</label>
                            <input v-model="calendar.url"
                                    id="calendar_url"
                                    name="calendar_url"
                                    class="form-control m-input"
                                    type="text"
                                    placeholder="カレンダーURL"
                                    :disabled="true">
                        </div>
                        <button
                            class="btn copy-btn"
                            @click="copyCalendarlink">
                            <div v-if="isCopiedCalendarUrl">
                                <span>コピーしました！</span>
                            </div>
                            <div v-else>
                                <span>URLをコピー</span>
                            </div>
                        </button>
                    </div>
                    <div v-else></div>
                </div>
            </div>
            
        </template>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                inProgress: false,
                calendar: {
                    is_public: 0,
                    url: "",
                },
                isCopiedCalendarUrl: false,
            };
        },

        created: function() {
            bus.$on('open-modal-doctor-calendar-export', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-calendar-export')
        },

        methods: {
            open: function () {
                this.modalShow = true
                this.fetchCalendarUrl()
            },

            close: function () {
                this.modalShow = false
            },

            /**
             * カレンダーURLのコピー
             */
             copyCalendarlink: function () {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(this.calendar.url).then(() => {
                        this.isCopiedCalendarUrl = true
                        setTimeout(() => this.isCopiedCalendarUrl = false, 1500)
                    })
                }
            },

            fetchCalendarUrl: async function () {
                const endpoint = `${constants.doctor.calendars.endpoint.base}`
                await axios.get(endpoint)
                    .then(({data}) => {
                        this.calendar.is_public = data.data.is_public
                        this.calendar.url = data.data.url
                        this.inProgress = false
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })
            },

            changeIsPublic: async function () {
                if(this.inProgress) return 
                this.inProgress = true

                const param = {
                    is_public: this.calendar.is_public
                }

                const endpoint = `${constants.doctor.calendars.endpoint.base}`
                await axios.put(endpoint, param)
                    .then(({data}) => {
                        this.fetchCalendarUrl()
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
.copy-btn{
    background: #d12e4f;
    color: white;

    &:hover {
        opacity: 0.7;
    }
}
</style>
